import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQItemm from './FAQItemm';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Morachichincholipunenear() {



    const cardData =
    {
        keyword: 'Morachi Chincholi Pune Nearby Attractions',
        heading: 'Anand Krushi Paryatan Kendra: Morachi Chincholi Pune Nearby Attractions',
        headingDescription: 'Planning a trip to Morachi Chincholi? Extend your journey by exploring some of the best Pune nearby attractions located just a short drive away. After enjoying the serene beauty and peacock sightings of Morachi Chincholi, you can visit historic sites like the Shivneri Fort (birthplace of Chhatrapati Shivaji Maharaj) or unwind at Nighoj Potholes, a rare geological wonder formed by the Kukadi River. Nature lovers will enjoy the lush landscapes of Ranjangaon Ganpati Temple (one of the Ashtavinayak temples) or the peaceful setting of Bhuleshwar Temple, perched on a hill. For families and kids, Anand Krushi Paryatan Kendra within Morachi Chincholi offers rural activities, traditional meals, and bullock cart rides. Whether you are seeking spirituality, adventure, or cultural experiences, the region around Morachi Chincholi offers plenty of nearby attractions to complete your day trip from Pune.',

        top: 'Top Activities at Anand Krushi Paryatan Kendra:',

        topPlaces: [
  {
    "title": "Peacock Sanctuary & Bird Watching",
    "description": "Morachi Chincholi is famed as Maharashtra’s ‘Peacock Village’, with hundreds of peafowls freely roaming around tamarind groves. Arrive early for the best sightings and stunning photo opportunities."
  },
  {
    "title": "Water Park & Rain Dance",
    "description": "Cool down in the vibrant on-site water park, complete with a full-sized swimming pool, rain dance zone, and colorful slides—ideal for family fun in the countryside."
  },
  {
    "title": "Bullock Cart & Tractor Safaris",
    "description": "Take relaxed bullock cart rides or thrilling tractor safaris through farmland and village roads—an immersive agritourism experience loved by all ages."
  },
  {
    "title": "Adventure Sports & Outdoor Games",
    "description": "Enjoy zip-lining, archery, cricket, volleyball, and badminton across sprawling grounds—perfect for groups and full-day fun."
  },
  {
    "title": "Traditional Village Games",
    "description": "Relive nostalgic rural games like gilli-danda, lagori, and kite-flying. Local hosts often guide these cultural activities, making them educational and engaging."
  },
  {
    "title": "Bonfire & Night Camping",
    "description": "Stay overnight in tents or dorms, and enjoy evening bonfires with storytelling and stargazing under the rural sky."
  },
  {
    "title": "Lenyadri Caves (~29 km)",
    "description": "Explore the ancient Buddhist rock-cut Lenyadri Caves near Junnar—dating from the 1st century and ideal for history buffs and spiritual seekers—just a short drive away."
  },
  {
    "title": "Takali Dhokeshwar Temple (~25 km)",
    "description": "Visit the serene Shiva temple at Takali Dhokeshwar, perched atop a hill—known for its peaceful atmosphere and panoramic countryside views."
  },
  {
    "title": "Pabal Jain Temple & Mastani Samadhi (~20 km)",
    "description": "Combine your trip with a visit to the ornate Pabal Jain temple and the romantic Mastani Samadhi, both rich in heritage and located within easy driving distance."
  },
  {
    "title": "Ranjangaon Mahaganpati (~20 km)",
    "description": "Pay your respects at the sacred Ashtavinayak shrine of Ganesh at Ranjangaon—a revered pilgrimage site steeped in tradition."
  }
],




"services": [
  {
    "name": "Tourist Spots Around Morachi Chincholi Pune",
    "description": "Anand Krushi Paryatan Kendra is one of the most recommended tourist spots near Morachi Chincholi Pune, offering a peaceful rural ambiance, close encounters with nature, and hands-on farming experiences. Located amidst open fields and native flora, it provides a refreshing alternative to typical city sightseeing."
  },
  {
    "name": "Places to Visit Near Morachi Chincholi",
    "description": "Alongside the famous peacock sightings, Anand Krushi Paryatan Kendra is a must-visit destination near Morachi Chincholi. It combines rural charm, traditional hospitality, and cultural experiences—making it a perfect inclusion in your itinerary when exploring nearby villages and attractions."
  },
  {
    "name": "Nature Parks Near Morachi Chincholi Pune",
    "description": "While not a conventional park, Anand Krushi Paryatan Kendra functions like a living nature space, featuring orchards, shaded trails, and farming landscapes. Ideal for nature lovers and eco-conscious visitors looking to escape into greenery near Morachi Chincholi."
  },
  {
    "name": "Cultural Attractions Near Morachi Chincholi",
    "description": "At Anand Krushi Paryatan Kendra, culture comes alive through folk music, rural games, bullock cart rides, and traditional Marathi meals. This working farm doubles as a cultural attraction, offering visitors an immersive look into the agrarian lifestyle of Maharashtra."
  },
  {
    "name": "Day Trips from Morachi Chincholi Pune",
    "description": "Looking for a fulfilling day trip from Morachi Chincholi? Anand Krushi Paryatan Kendra provides a full-day rural experience—complete with meals, farming demonstrations, and play areas for kids. Perfect for families, couples, and groups wanting to unwind in nature."
  },
  {
    "name": "Temples Near Morachi Chincholi",
    "description": "Combine your visit to Anand Krushi Paryatan Kendra with nearby spiritual sites such as Moreshwar Temple (Morgaon) or Jejuri Khandoba Temple. After exploring local heritage, relax at the farm with a wholesome village thali and serene rural views."
  },
  {
    "name": "Historical Sites Nearby",
    "description": "Stay at Anand Krushi Paryatan Kendra and take short trips to nearby historical gems like Shivneri Fort or Bhuleshwar Temple. After a day of exploring ancient architecture and history, return to a relaxing farm setting to recharge."
  },
  {
    "name": "Adventure Parks Close to Morachi Chincholi",
    "description": "If you're seeking light adventure, Anand Krushi Paryatan Kendra offers rural-themed thrills like obstacle games, tractor rides, rope balancing, and interactive farming tasks. It's a fun and educational alternative to conventional amusement parks near Morachi Chincholi."
  },
  {
    "name": "Wildlife Sanctuaries Nearby",
    "description": "While not a formal sanctuary, Anand Krushi Paryatan Kendra sits close to natural areas where peacocks, kingfishers, and other native wildlife thrive. The surroundings offer excellent birdwatching and peaceful interaction with Maharashtra’s natural beauty."
  },
  {
    "name": "Local Markets Near Morachi Chincholi",
    "description": "Visit Anand Krushi Paryatan Kendra and then explore nearby rural markets offering fresh produce, handmade snacks, traditional clothes, and local crafts. You can also buy farm-made products directly from the resort—like jaggery, pickles, and seasonal fruits."
  },
  {
    "name": "Picnic Spots Near Morachi Chincholi Pune",
    "description": "Anand Krushi Paryatan Kendra is a top-rated picnic destination near Morachi Chincholi. With shaded gazebos, open play areas, a traditional meal experience, and space for relaxation, it's ideal for a wholesome day out with loved ones."
  },
  {
    "name": "Weekend Getaway Spots Near Morachi Chincholi",
    "description": "Planning a weekend escape from Pune or around Morachi Chincholi? Anand Krushi Paryatan Kendra offers a peaceful countryside retreat filled with nature, culture, and food. Stay for a day or camp overnight—it's perfect for reconnecting with simplicity and nature."
  },
  {
    "name": "Eco-Friendly Resorts Near Morachi Chincholi",
    "description": "Anand Krushi Paryatan Kendra is proudly eco-friendly—using organic farming practices, recycling water, and promoting sustainable tourism. Guests can learn about green living while enjoying authentic rural experiences in a clean, nature-friendly environment."
  },
  {
    "name": "Waterfalls Near Morachi Chincholi",
    "description": "While the immediate area is known more for its plains and farms, Anand Krushi Paryatan Kendra can serve as a relaxing base for short drives to nearby seasonal waterfalls during monsoon. Enjoy nature’s rhythm at the farm before venturing out to explore surrounding water spots."
  },
  {
    "name": "Resorts with Activities Near Morachi Chincholi",
    "description": "Few resorts near Morachi Chincholi offer the range of activities you'll find at Anand Krushi Paryatan Kendra—nature walks, farming games, bullock cart rides, local food-making, and even evening bonfires. It’s a destination that turns a short trip into a memorable experience."
  }
],
"tableData": [
  ["Tourist Spots Around Morachi Chincholi Pune", "- Places to Visit Near Morachi Chincholi"],
  ["Nature Parks Near Morachi Chincholi Pune", "- Cultural Attractions Near Morachi Chincholi"],
  ["Day Trips from Morachi Chincholi Pune", "- Temples Near Morachi Chincholi"],
  ["Historical Sites Nearby", "- Adventure Parks Close to Morachi Chincholi"],
  ["Wildlife Sanctuaries Nearby", "- Local Markets Near Morachi Chincholi"],
  ["Picnic Spots Near Morachi Chincholi Pune", "- Weekend Getaway Spots Near Morachi Chincholi"],
  ["Eco-Friendly Resorts Near Morachi Chincholi", "- Waterfalls Near Morachi Chincholi"],
  ["Resorts with Activities Near Morachi Chincholi", "- "]
],



"whychoose": [
  {
    "WhyChooseheading": "Convenient Location from Pune",
    "WhyChoosedescription": "Anand Krushi Paryatan Kendra is located just 55 km from Pune, making it an ideal one-day picnic destination. Easily accessible by road, it offers a scenic countryside drive and a quick getaway from the city's hustle and bustle."
  },
  {
    "WhyChooseheading": "Peacock Watching in Natural Habitat",
    "WhyChoosedescription": "Morachi Chincholi is famous for its large population of peacocks roaming freely among the ancient tamarind trees. Visitors can witness the stunning peacock displays, especially during early mornings and evenings, providing a unique wildlife experience."
  },
  {
    "WhyChooseheading": "Authentic Village and Agritourism Experience",
    "WhyChoosedescription": "Guests can experience traditional village life through bullock cart rides, tractor tours, organic farming demonstrations, and interaction with local farmers. The center offers hands-on activities such as vegetable picking and animal feeding for an immersive rural experience."
  },
  {
    "WhyChooseheading": "Fun Activities for Kids and Families",
    "WhyChoosedescription": "Anand Krushi Paryatan Kendra offers puppet shows, magic performances, traditional rural games, and animal feeding zones that entertain children. Family-friendly zones with play areas and spots to relax make it enjoyable for visitors of all ages."
  },
  {
    "WhyChooseheading": "Adventure and Outdoor Sports",
    "WhyChoosedescription": "For adventure enthusiasts, there are activities like zip-lining, archery, rope climbing, and boating. The expansive open spaces accommodate games like cricket and volleyball, and the rain dance area adds fun during hot days."
  },
  {
    "WhyChooseheading": "Seasonal Festivals and Cultural Events",
    "WhyChoosedescription": "Visitors can enjoy traditional seasonal festivals like Hurda parties in winter and Mango Mahotsav in summer. These events showcase local produce, rural entertainment, and cultural programs that celebrate village traditions."
  },
  {
    "WhyChooseheading": "Camping, Bonfires, and Stargazing",
    "WhyChoosedescription": "Stay overnight in cozy tents under the stars and enjoy bonfire evenings. Nature trails and peaceful surroundings offer a serene escape and a chance to reconnect with nature in a rustic ambiance."
  },
  {
    "WhyChooseheading": "Affordable All-Inclusive Packages",
    "WhyChoosedescription": "With budget-friendly packages starting from ₹600 for adults and ₹300 for children, Anand Krushi Paryatan Kendra offers meals, farm rides, and access to all activities. This makes it an excellent value-for-money option for families, schools, and corporate groups."
  }
]





    }

const faqData = [
  {
    id: 'FAQ1',
    question: 'What makes Morachi Chincholi a unique attraction near Pune?',
    answer: 'Morachi Chincholi is famous for its natural peacock habitat, traditional rural lifestyle, and agritourism spots like Anand Krushi Paryatan Kendra. It offers a peaceful break from city life just 65 km from Pune.',
  },
  {
    id: 'FAQ2',
    question: 'Which nearby attractions can be visited along with Morachi Chincholi?',
    answer: 'Nearby attractions include Ranjangaon Mahaganpati Temple (Ashtavinayak), Alandi Temple, Shikrapur sugar factories (educational visits), and local farms offering agritourism experiences.',
  },
  {
    id: 'FAQ3',
    question: 'Is Morachi Chincholi suitable for a weekend family outing?',
    answer: 'Yes. With nature trails, peacock sightings, farm visits, and kids’ activities, it’s ideal for a family day trip or rural weekend retreat.',
  },
  {
    id: 'FAQ4',
    question: 'Can we visit Morachi Chincholi as part of a pilgrimage circuit?',
    answer: 'Absolutely. Many visitors combine it with a spiritual trip to Ranjangaon Ganpati, Alandi, or Jejuri—all within 1–2 hours from Morachi Chincholi.',
  },
  {
    id: 'FAQ5',
    question: 'Are there any wildlife or birdwatching opportunities?',
    answer: 'Yes. Peacock sightings are the main attraction, especially during early mornings and post-monsoon. You may also spot parrots, kingfishers, and rural flora and fauna.',
  },
  {
    id: 'FAQ6',
    question: 'What kind of accommodation is available near Morachi Chincholi?',
    answer: 'Many agritourism centers like Anand Krushi offer day-picnic packages. Some also offer simple overnight stays with basic rural accommodations.',
  },
  {
    id: 'FAQ7',
    question: 'Is the route to Morachi Chincholi scenic or accessible?',
    answer: 'Yes, the route via Alandi or Shikrapur is straightforward and scenic, especially during monsoon with lush greenery along the way.',
  },
  {
    id: 'FAQ8',
    question: 'What should tourists carry while visiting?',
    answer: 'Carry hats, sunglasses, water bottles, insect repellent, and a camera. Casual clothes and sports shoes are recommended for walking trails.',
  },
  {
    id: 'FAQ9',
    question: 'Is there any cultural experience for tourists?',
    answer: 'Yes! You can witness traditional village life, bullock-cart rides, local Maharashtrian meals, and sometimes even folk performances during festivals.',
  },
  {
    id: 'FAQ10',
    question: 'Are bookings required for nearby attractions or activities?',
    answer: 'For major temples like Ranjangaon, no booking is needed. For farm visits or picnics at Morachi Chincholi, pre-booking is recommended especially on weekends.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Nilesh Pawar, Pune',
    feedback: "Morachi Chincholi gave us the perfect one-day escape from Pune. We visited the Ranjangaon Ganpati Temple in the morning, followed by a peaceful afternoon at Anand Krushi watching peacocks and enjoying rural games.",
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Manisha Patil, Navi Mumbai',
    feedback: "We loved exploring nearby attractions like Alandi and then relaxing in Morachi Chincholi. The natural vibe, fresh food, and peacock sightings made our family trip memorable!",
    rating: 4,
  },
];






    const carouselItems = testimonials.map(testimonial => (
        <div key={testimonial.name}>
            <blockquote>

                <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
                <footer className=' user'>— {testimonial.name}</footer>
            </blockquote>
        </div>
    ));

    const carouselOptions = {
        loop: true,
        margin: 10,
        nav: true,
        items: 1
    };

    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9689125047",
            "+91 9623755047",
            "+91 9673132497",


        ],
        email: "thopatemala@gmail.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "One Day Picnic Spot Near Pune for Family",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "One Day Trip Near Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Picnic Spot Near Pune ",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Picnic Destination Near Pune ",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Corporate Outing Resorts Near Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Agri Tourism Near Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Destination Wedding Near Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Hurda Party Places Near Pune",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Water Park Near Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "School Picnic Spots Near Pune for Students",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "One Day Adventure Resorts Near Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Resort Near Pune ",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Forest Resorts Near Pune ",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Nature resorts near pune for weekend",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mango Mahotsav in Pune",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Krushi Paryatan Kendra near Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Camping Places Near Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Activities Resort Near Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Agro Tourism Near Mumbai for Family",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "One Day Picnic Spot From Mumbai",
        },
        {
            place: "/images/keyword/21.jpg",
            text: "One Day Picnic Packages Near Mumbai",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "School Picnic Spots in Mumbai",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Resort Near Mumbai ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Team Outing Places Near Mumbai",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Corporate Outing Near Mumbai",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Picnic Spot Near Nashik",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Farm House On Rent in Pune ",
        },
    ];


    const images = [
        { src: "/images/gallery/01.jpg", alt: "Image 1" },
        { src: "/images/gallery/02.jpg", alt: "Image 1" },
        { src: "/images/gallery/03.jpg", alt: "Image 1" },
        { src: "/images/gallery/04.jpg", alt: "Image 1" },
        { src: "/images/gallery/05.jpg", alt: "Image 1" },
        { src: "/images/gallery/06.jpg", alt: "Image 1" },
        { src: "/images/gallery/07.jpg", alt: "Image 1" },
        { src: "/images/gallery/08.jpg", alt: "Image 1" },
        { src: "/images/gallery/09.jpg", alt: "Image 1" },
        { src: "/images/gallery/010.jpg", alt: "Image 1" },
        { src: "/images/gallery/011.jpg", alt: "Image 1" },
        { src: "/images/gallery/012.jpg", alt: "Image 1" },

    ];

const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Morachi Chincholi Pune Nearby Attractions",
  "image": "https://morachichincholi.in/assets/images/morachi-chincholi-pune-nearby-attractions.jpg",
  "description": "Explore tourist spots near Morachi Chincholi in Pune including nature parks, temples, cultural sites, adventure zones, and picnic areas. Stay at Anand Krushi Paryatan Kendra and enjoy a perfect weekend getaway surrounded by nature.",
  "brand": {
    "@type": "Brand",
    "name": "Anand Krushi Paryatan Kendra"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "1743"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "600",
    "availability": "https://schema.org/InStock",
    "url": "https://morachichincholi.in/morachi-chincholi-pune-nearby-attractions"
  }
};




    return (
        <div>
<Helmet>
  <title>Morachi Chincholi Pune Nearby Attractions | Nature & Heritage Getaways | Anand Krushi Paryatan Kendra</title>
  <meta 
    name="description" 
    content="Discover nearby attractions around Morachi Chincholi in Pune – including temples, cultural spots, nature parks, picnic areas, and weekend getaways. Stay at Anand Krushi Paryatan Kendra for an eco-friendly and fun experience." 
  />
  <meta 
    name="keywords" 
    content="Tourist spots around Morachi Chincholi Pune, Places to visit near Morachi Chincholi, Nature parks near Morachi Chincholi Pune, Cultural attractions near Morachi Chincholi, Day trips from Morachi Chincholi Pune, Temples near Morachi Chincholi, Historical sites nearby, Adventure parks close to Morachi Chincholi, Wildlife sanctuaries nearby, Local markets near Morachi Chincholi, Picnic spots near Morachi Chincholi Pune, Weekend getaway spots near Morachi Chincholi, Eco-friendly resorts near Morachi Chincholi, Waterfalls near Morachi Chincholi, Resorts with activities near Morachi Chincholi" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section className="breadcrumb-main pb-20 pt-14" style={{ backgroundImage: 'url(images/bg/bg1.jpg)' }}>
                <div className="section-shape section-shape1 top-inherit bottom-0" style={{ backgroundImage: 'url(images/shape8.png)' }}></div>
                <div className="breadcrumb-outer">
                    <div className="container">
                        <div className="breadcrumb-content text-center">
                            <h1 className="mb-3"> {cardData.keyword}</h1>

                        </div>
                    </div>
                </div>
                <div className="dot-overlay"></div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/4.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#609F31', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 darkcolor'> Why Choose Anand Krushi Paryatan Kendra for {cardData.keyword + " Rates"}</h3>
                            {/* <BusRatesTable /> */}

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 darkcolor"> {item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">fAQS {cardData.keyword} For Anand Krushi Paryatan Kendra</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                {faqData.map((faq) => (
                                                    <FAQItemm key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <div>

                                <div className="contact-box Borderr">
                                    <h3 className='darkcolor'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Gallery</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image py-1"

                                            />
                                        </div>
                                    ))}
                                    {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #609F31',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#609F31' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2 text-white"></i>
                                            <div className=''>
                                                <a href="tel:+919689125047" className="d-block  text-white">+91 9689125047</a>
                                                <a href="tel:+919623755047" className="d-block  text-white">+91 9623755047</a>
                                                <a href="tel:+919673132497" className="d-block  text-white">+91 9673132497</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <i className="bi bi-envelope fs-1 mb-2 text-white"></i>
                                                <a href="mailto:thopatemala@gmail.com" className=" text-white d-block">
                                                    thopatemala@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <i className="bi bi-house-fill fs-1 mb-2 text-white"></i>
                                                <p className="whit text-white ">
                                                    <i> Anand Krushi Paryatan Kendra <br />
                                                        Dattatraya Anandrao Thopate, Topate Vasti, Chincholi Morachi, Tal. Shirur, Dist. Pune. Maharashtra - 412218

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Morachichincholipunenear;